export default {"src":"/_next/static/media/41-cake.e8d15bb9.svg","height":118,"width":293};